<template>
    <div>
        <button-white @click="open">
            Bearbeiten
        </button-white>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">
                    Ausstattung bearbeiten
                </template>

                <div class="flex justify-end">
                   <attribute-delete :attribute="attribute" @leaveModal="setModalFalse"> </attribute-delete>
                </div>

                <input-text v-model="name" class="mb-8">
                    Name der Ausstattung
                </input-text>

                <div class="flex justify-end" v-show="!loading">
                    <button-primary @click="save">
                        <template slot="icon"><i class="fa fa-save"></i></template> Speichern
                    </button-primary>
                </div>

                <loading v-show="loading"></loading>

            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonWhite from "../UI/ButtonWhite.vue";
import Modal from "../Modal.vue";
import ButtonPrimary from "../UI/ButtonPrimary.vue";
import InputText from "../UI/InputText.vue";
import Loading from "../UI/Loading.vue";
import ButtonDelete from "../UI/ButtonDelete.vue";
import ConfirmDialog from "../UI/ConfirmDialog.vue";
import AttributeDelete from './AttributeDelete.vue';

export default {
    name: "AttributeEdit",

    components: {ConfirmDialog, ButtonDelete, Loading, InputText, ButtonPrimary, Modal, ButtonWhite, AttributeDelete},

    props: ['attribute'],

    data: () => ({
        showModal: false,
        loading: false,
        name: '',
    }),

    methods: {

        setModalFalse(){
            this.showModal = false;
            this.loading = false;
            this.$emit('updated');
        },

        open() {
            this.showModal = true;
            this.name = this.attribute.name;
        },
        save() {
            this.loading = true;
            this.$http
                .post('/admin/attributes/' + this.attribute.id, {
                    _method: 'put',
                    name: this.name,
                })
                .then(() => {
                    this.loading = false;
                    this.$emit('updated');
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
       
    },
}
</script>

<style scoped>

</style>